import {TrainingStudentTypeDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createTrainingStudentType(
    userData: Record<string, string>,
    trainingStudentType: Record<string, any>
) {
    try {
        const result = await TrainingStudentTypeDao.createTrainingStudentType(userData.userToken, trainingStudentType);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
